import { LOCALE_ID, Provider } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export class LocaleId extends String {
  constructor(private translateSvc: TranslateService) {
    super();
  }

  override toString(): string {
    return this.translateSvc.currentLang()!;
  }

  override valueOf(): string {
    return this.toString();
  }
}

export const LocaleProvider: Provider = {
  provide: LOCALE_ID,
  useClass: LocaleId,
  deps: [TranslateService],
};
